import {Component, Host, h, Prop, Element} from '@stencil/core';

@Component({
  tag: 'me-teaser',
  styleUrl: 'me-teaser.scss',
  shadow: false,
})
export class MeTeaser {

  @Element() host: HTMLElement;

  @Prop() variant = 'normal';
  @Prop() target = '_self';
  @Prop({ reflect: true }) href: string;
  @Prop({ reflect: true }) hrefHeadline?: string;
  @Prop({ reflect: true }) hrefSubheadline?: string;
  @Prop() read = false;

  private hasBadge = false;
  private hasSubheadline = false;

  componentWillLoad() {
    this.hasBadge = Boolean(this.host.querySelector(':scope *[slot=badge]'));
    this.hasSubheadline = Boolean(this.host.querySelector(':scope *[slot=subheadline]'));
  }

  render() {
    const classList = [
      'me-teaser',
      `me-teaser--${this.variant}`,
      this.read ? `me-teaser--read` : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList}>
        <div class="me-teaser__image">
          <a class="me-teaser__image-link" href={this.href}  target={this.target}>
            <slot name="image" />
          </a>
        </div>
        <div class="me-teaser__icon-wrapper">
          <div class="me-teaser__icons">
            <div class="me-teaser__social-icons">
              <slot name="like" />
              <slot name="comment" />
              <slot name="share" />
            </div>
            <slot name="bookmark" />
            <slot name="summary" />
          </div>
        </div>
        <div class="me-teaser__header">
          <div class="me-teaser__text">
            {this.hasSubheadline
              ? (
                <me-headline
                  href={this.hrefSubheadline ?? this.href}
                  target={this.target}
                  variant="teaser-subheading"
                >
                  <slot name="subheadline" />
                </me-headline>
              )
              : ''
            }
            <me-headline
              href={this.hrefHeadline ?? this.href}
              target={this.target}
              tag="h3"
              variant="teaser"
            >
              {this.hasBadge
                ? (
                  <span slot="icon-left">
                    <slot name="badge" />
                  </span>
                )
                : ''
              }
              <slot name="headline" />
            </me-headline>
          </div>
          <div class="me-teaser__details">
            <slot name="details" />
          </div>
        </div>
        <div class="me-teaser__body">
          <slot name="body" />
        </div>
      </Host>
    );
  }
}
